export default __webpack_public_path__ + "static/media/heroIllustration.c0b0d87a.svg";